import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Founder from "@/pages/Founder";
import Services from "@/pages/Services";
import TrainingPrograms from "@/pages/TrainingPrograms";
import PreTripInspection from "@/pages/PreTripInspection";
import SafetyTopics from "@/pages/SafetyTopics";
import ForTrainees from "@/pages/ForTrainees";
import ForDistricts from "@/pages/ForDistricts";
import PretripGuide from "@/pages/PretripGuide";
import TrainingMaterials from "@/pages/TrainingMaterials";
import Resources from "@/pages/Resources";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/founder" element={<Founder />} />
            <Route path="/services" element={<Services />} />
            <Route path="/training-programs" element={<TrainingPrograms />} />
            <Route path="/pre-trip-inspection" element={<PreTripInspection />} />
            <Route path="/safety-topics" element={<SafetyTopics />} />
            <Route path="/for-trainees" element={<ForTrainees />} />
            <Route path="/for-districts" element={<ForDistricts />} />
            <Route path="/pretrip-guide" element={<PretripGuide />} />
            <Route path="/training-materials" element={<TrainingMaterials />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <Toaster theme="dark" position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
